<script>
import TableBlock from '@/components/Analysis/TableBlockMixin';
import { extendedTimeRangesCaptions, timeRangesCaptions } from '@/pure/ComputedData';

export default {
  mixins: [TableBlock],
  props: ['percentMode'],

  computed: {
    computedData() {
      const { filteredCollaboratorsCount, collaboratorsByTimeRanges, sites, filteredCollaborators, useExtendedTimeRanges } = this.data;
      const computedSites = this.range ? sites.slice(this.range[0], this.range[1]) : sites;
      const supHeaderCaption = useExtendedTimeRanges ? extendedTimeRangesCaptions : timeRangesCaptions;
      const subInfo = { supHeaderCaption };

      const specifications = [
        {
          className: 'current-site site empty',
        },
        ...supHeaderCaption.map(h => ({
          type: 'heading',
          caption: h,
        })),
      ];

      const entries = computedSites.map(site => {
        let result = [this.buildSiteBlock(site, filteredCollaborators, this.forcedTransport)];

        if (this.percentMode) {
          let percentages = [];
          site.details.collaboratorsByTimeRanges.forEach((item, index) =>
            percentages.push({
              index,
              ...item,
              percentage: filteredCollaborators.length ? (item.count / filteredCollaborators.length) * 100 : 0,
            }),
          );

          const diff = 100 - percentages.map(e => Math.floor(e.percentage)).reduce((acc, val) => acc + val, 0);
          const sortedPercentages = percentages.sort((a, b) => Math.floor(a.percentage) - a.percentage - (Math.floor(b.percentage) - b.percentage));
          const percentageResult = sortedPercentages.map((e, index) => {
            const percentage = index < diff ? Math.floor(e.percentage) + 1 : Math.floor(e.percentage);
            return { ...e, value: `${percentage}%` };
          });

          result = [...result, ...percentageResult.sort((a, b) => a.index - b.index)];
        } else {
          site.details.collaboratorsByTimeRanges.forEach(item => result.push({ value: item.count }));
        }

        return result;
      });

      const currentSiteEntries = [
        {
          caption: this.$t('actualSites', this.data.actualSites.length),
          className: 'current-site site',
          type: 'current-site',
        },
        ...collaboratorsByTimeRanges.map(c => {
          return {
            caption: this.percentMode
              ? filteredCollaborators.length
                ? `${((c.count / filteredCollaborators.length) * 100).toFixed(0)}%`
                : '0%'
              : `${c.count}`,
            className: 'current-site',
          };
        }),
      ];

      const data = this.percentMode
        ? this.computeTimeTable(
            collaboratorsByTimeRanges.map(item => `${((item.count / filteredCollaborators.length) * 100).toFixed(0)}%`),
            entries,
            subInfo,
          )
        : this.computeTimeTable(
            collaboratorsByTimeRanges.map(item => item.count),
            entries,
            subInfo,
          );

      return {
        heading: {
          caption: this.$t('collaboratorsByAccessTime'),
          icon: 'clock',
          baseline: {
            value: filteredCollaboratorsCount,
            caption: `${this.$t('collaboratorsNumber')} :`,
          },
        },
        data: {
          specifications,
          entries: [currentSiteEntries, ...data.entries],
        },
      };
    },
  },
};
</script>
